import React, { useState, useEffect, useRef } from "react";
import pClasses from "../Users.module.scss";
import MuiDialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

import IconButton from "@mui/material/IconButton";
import Grid from "@mui/material/Grid";
// import Button from "@mui/material/Button";
// import Select from "@mui/material/Select";
// import MenuItem from "@mui/material/MenuItem";
// import RoundButton from "../../../../components/Buttons/RoundButton";
import { useTranslation } from "react-i18next";

interface Interface {
  open: any;
  onCloseModal: any;
  openModalAlertTitle: any;
  openModalAlertMessage: any;
  openModalAlertIcon: any;
  openModalAlertButtons: any;
}

export default function Profile({
  open,
  onCloseModal,
  openModalAlertTitle,
  openModalAlertMessage,
  openModalAlertIcon,
  openModalAlertButtons,
}: Interface) {
  const [content, setContent] = useState(<></>);
  const { t } = useTranslation();

  useEffect(() => {
    setContent(
      <Dialog
        onClose={onCloseModal}
        aria-labelledby="customized-dialog-title"
        open={open}
        className={pClasses.ProfileContainerAlert}
        fullWidth={true}
        maxWidth="md"
      >
        <MuiDialogTitle className={pClasses.top}>
          <Grid justifyContent="flex-end" container>
            <IconButton
              aria-label="close"
              className={pClasses.closeButton}
              onClick={onCloseModal}
              size="small"
            >
              <FontAwesomeIcon
                className={pClasses.icon}
                icon={faTimes}
                size="xs"
              />
            </IconButton>
          </Grid>
          <Grid justifyContent="center" container>
            <h2 className={pClasses.upperModalAlert}>{openModalAlertTitle}</h2>
          </Grid>
          <Grid justifyContent="center" container>
            <div className={pClasses.iconAlert}>{openModalAlertIcon}</div>
          </Grid>
          <Grid justifyContent="center" container>
            <div className={pClasses.contentModalAlert}>
              {openModalAlertMessage}
            </div>
          </Grid>
          <Grid justifyContent="center" container>
            {openModalAlertButtons}
          </Grid>
        </MuiDialogTitle>
      </Dialog>
    );
  }, [open, openModalAlertTitle, openModalAlertMessage, openModalAlertIcon, openModalAlertButtons]);

  return content;
}
